// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e6bbd0cc","58":"6fb4189f","72":"6fab434d","417":"cfcec99d","458":"357f7f0a","579":"eac2b102","650":"8a73038e","724":"4824ebc7","747":"4b6ef617","773":"dfd8538d"}[chunkId] + ".chunk.js";
};